<template>
  <div>
    <!-- :large="OSS_PIC_BASE_URL + info.name + '?x-oss-process=image/resize,h_800,m_lfit'" -->
    <img
      :src="info.url"
      style="width: 100px;height: 100px;"
      :preview="type"
      :large="OSS_PIC_BASE_URL + info.name"
    />
    <a-icon
      type="close-circle"
      style="position: absolute;right: 24px;top: 4px;"
      @click="$emit('removeFile', info, type)"
    />
    <div @click="visible = true">
      <a-tooltip>
        <template slot="title">
          <span>{{
            info.lng && info.lat ? info.lng + "," + info.lat : "选择经纬度"
          }}</span>
        </template>
        <div style="display: flex;align-items: center;">
          <span class="lng-lat">{{
            info.lng && info.lat ? info.lng + "," + info.lat : ""
          }}</span
          ><a-icon type="environment" />
        </div>
      </a-tooltip>
    </div>
    <a-modal
      :visible="visible"
      forceRender
      destroyOnClose
      :footer="null"
      @cancel="visible = false"
      :width="960"
      :bodyStyle="{ padding: '24px 0 0' }"
    >
      <select-lng-lat-in-map
        v-if="visible"
        :trackDataInfo="trackDataInfo"
        @getLngLat="getLngLat"
        :curLngLat="info.lng && info.lat ? info.lng + ',' + info.lat : ''"
      ></select-lng-lat-in-map>
    </a-modal>
  </div>
</template>

<script>
import SelectLngLatInMap from "@/components/SelectLngLatInMap";
import { OSS_PIC_BASE_URL } from "@/config/config";
export default {
  data() {
    return {
      visible: false,
      OSS_PIC_BASE_URL
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    trackDataInfo: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ""
    }
  },
  components: {
    SelectLngLatInMap
  },
  methods: {
    getLngLat(value) {
      this.$emit("getLngLatInfo", value, this.info, this.type);
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.lng-lat {
  width: 88px;
  height: 24px;
  line-height: 24px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid #ccc;
  margin: 2px;
  border-radius: 4px;
}
</style>
